export default "__VITE_ASSET__70e08828__"